/* eslint-disable no-param-reassign */
/* eslint-disable no-return-assign */
import axios from '@axios'

const getDefaultState = () => ({
  items: [],
  item: null,
  searchFields: '',
  orderBy: '',
  sortedBy: '',
  types: [],
  usageTypes: [],
  pagination: {
    current_page: 1,
    last_page: 1,
    per_page: 25,
    total: 0,
  },
})

export default {
  namespaced: true,
  state: getDefaultState,
  getters: {},
  mutations: {
    SET_ITEMS(state, payload) {
      state.items = payload
    },
    SET_PAGINATION(state, payload) {
      state.pagination = payload
    },
    SET_ITEM(state, payload) {
      state.item = { ...payload }
    },
    UPDATE_ITEM(state, payload) {
      state.items = state.items.map(item => {
        if (item.id === payload.id) {
          return payload
        }

        return item
      })
    },
    SET_SEARCH_FIELDS(state, fields) {
      state.searchFields = fields
    },
    SET_ORDER_BY(state, order) {
      state.orderBy = order
    },
    SET_SORTED_BY(state, field) {
      state.sortedBy = field
    },
    SET_TYPES_OPTIONS(state, payload) {
      state.types = payload.data.map(item => ({
        value: item.id,
        text: item.name,
      }))
    },
    SET_USAGE_TYPES_OPTIONS(state, payload) {
      state.usageTypes = payload.data.map(item => ({
        value: item.id,
        text: item.name,
      }))
    },
    DELETE_ITEM(state, payload) {
      if (!payload.id) {
        state.items = state.items.filter(item => (item.id !== payload))
      } else {
        state.items = state.items.map(item => {
          if (item.children) {
            return { ...item, children: item.children.filter(itemEnd => (itemEnd.id !== payload.id)) }
          }
          return item
        })
      }
    },
    RESET_ITEM(state) {
      state.item = null
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    async getItems({ commit }, { ...payload }) {
      try {
        const { data } = await axios.get('/network/subnet/index?&ip_version=ipv4', { params: { ...payload } })
        const { pagination } = data.meta
        const { options } = data
        const {
          searchFields, search, orderBy, sortedBy,
        } = payload
        data.data.map(item => {
          if (item.ends && item.ends.length > 0) {
            return item.children = [...item.ends]
          }
          return item.ends
        })
        if (searchFields && search) {
          commit('SET_SEARCH_FIELDS', searchFields)
        }

        if (orderBy && sortedBy) {
          commit('SET_ORDER_BY', orderBy)
          commit('SET_SORTED_BY', sortedBy)
        }

        if (options && options.types) {
          commit('SET_TYPES_OPTIONS', options.types)
        }

        if (options && options.usageTypes) {
          commit('SET_USAGE_TYPES_OPTIONS', options.usageTypes)
        }

        commit('SET_ITEMS', data.data)
        commit('SET_PAGINATION', pagination)

        return data.data
      } catch (error) {
        commit('SET_ITEMS', [])
        return Promise.reject(error)
      }
    },
    async getItem({ commit }, id) {
      try {
        const { data } = await axios.get(`/network/subnet/${id}/show`)
        commit('SET_ITEM', data.data)

        return data.data
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    // eslint-disable-next-line no-unused-vars
    async createItem({ commit }, payload) {
      try {
        await axios.post('/network/subnet/store', {
          ...payload,
        })

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async updateItem({ commit }, { id, ...payload }) {
      try {
        await axios.put(`/network/subnet/${id}/update`, {
          ...payload,
        })

        commit('UPDATE_ITEM', payload)

        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    async deleteItem({ commit }, payload) {
      try {
        if (!payload.id) {
          await axios.delete(`/network/subnet/${payload}/destroy`)
        } else {
          await axios.delete(`/network/subnet/${payload.id}/destroy`)
        }
        commit('DELETE_ITEM', payload)
        return true
      } catch (error) {
        commit('RESET_ITEM', [])
        return Promise.reject(error)
      }
    },
    async recoverItem({ commit }, id) {
      try {
        await axios.put(`/network/subnet/${id}/recover`)

        commit('RESET_ITEM')
        return true
      } catch (error) {
        return Promise.reject(error)
      }
    },
    setSearchFields({ commit }, payload) {
      commit('SET_SEARCH_FIELDS', payload)
    },

    setOrderBy({ commit }, payload) {
      commit('SET_ORDER_BY', payload)
    },
    setSortedBy({ commit }, payload) {
      commit('SET_SORTED_BY', payload)
    },
  },
}
